import { NgModule } from "@angular/core";
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from "@progress/kendo-angular-label";
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IntlModule } from "@progress/kendo-angular-intl";
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import '@progress/kendo-angular-intl/locales/fr/all';

@NgModule({
    exports: [
        InputsModule,
        LabelModule,
        DropDownsModule,
        IntlModule,
        DateInputsModule
    ]
})
export class KendoModule {}